import App from "./App";
import "./Styles/Style.scss";
import ReactDOM from "react-dom/client";
import config from "./config/config.json";
import { BrowserRouter } from "react-router-dom";
import ContextProviders from "./Contexts/ContextProviders";

const root = ReactDOM.createRoot(document.getElementById("root"));

if (config.NODE_ENV === "live") {
  const noop = () => {};

  if (window.REACT_DEVTOOLS_GLOBAL_HOOK) {
    window.REACT_DEVTOOLS_GLOBAL_HOOK.inject = noop;
  }

  // ============================
  // Internet Disconnected
  // ============================

  const showOfflinePage = () => {
    document.body.innerHTML = `
      <div style="
        min-height:100vh;
        display:flex;
        align-items:center;
        justify-content:center;
        background:#f5f7fa;
        padding:20px;
      ">
        <div style="
          max-width:600px;
          width:100%;
          background:#fff;
          padding:40px;
          border-radius:10px;
          box-shadow:0 4px 15px rgba(0,0,0,.08);
          text-align:center;
        ">
          <h1 style="
            color:#103c5e;
            margin-bottom:20px;
            font-size:34px;
          ">
            No Internet Connection
          </h1>

          <p style="
            color:#555;
            line-height:1.8;
            font-size:17px;
            margin-bottom:30px;
          ">
            Your internet connection appears to be unavailable.
            Please check your network connection and try again.
          </p>

          <button
            onclick="window.location.reload()"
            style="
              background:#103c5e;
              color:#fff;
              border:none;
              padding:12px 45px;
              border-radius:6px;
              cursor:pointer;
              font-size:16px;
            "
          >
            Retry
          </button>
        </div>
      </div>
    `;
  };

  window.addEventListener("offline", showOfflinePage);

  window.addEventListener("online", () => {
    window.location.reload();
  });

  if (!navigator.onLine) {
    showOfflinePage();
  }
}

root.render(
  <BrowserRouter>
    <ContextProviders>
      <App />
    </ContextProviders>
  </BrowserRouter>
);